/**
 * Gera um slug SEO-friendly a partir de um texto.
 * Ex: "Agricampanha realiza 8º Dia de Campo em Bagé" → "agricampanha-realiza-8o-dia-de-campo-em-bage"
 */
export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')                    // separa letras de acentos
    .replace(/[\u0300-\u036f]/g, '')     // remove os acentos
    .replace(/[°º]/g, 'o')              // ° e º → o
    .replace(/[^a-z0-9\s-]/g, '')       // remove caracteres especiais
    .trim()
    .replace(/\s+/g, '-')               // espaços → hífens
    .replace(/-+/g, '-')                // hífens duplos → simples
    .replace(/^-|-$/g, '')              // remove hífens no início/fim
    .slice(0, 100);                     // limita a 100 chars
}

/**
 * Gera um slug único acrescentando um sufixo numérico se necessário.
 * Usa uma função assíncrona de verificação fornecida pelo chamador.
 */
export async function generateUniqueSlug(
  text: string,
  exists: (slug: string) => Promise<boolean>
): Promise<string> {
  const base = generateSlug(text);
  if (!(await exists(base))) return base;

  let counter = 2;
  while (counter < 100) {
    const candidate = `${base}-${counter}`;
    if (!(await exists(candidate))) return candidate;
    counter++;
  }
  // Fallback com timestamp
  return `${base}-${Date.now()}`;
}
